export const DEFAULT_BRANDING_NAME = "CyberSentriq";
export const DEFAULT_BRANDING_EMAIL = "no-reply@training-shield.com";
export const DEFAULT_BRANDING_LIGHT_LOGO_NAME = "Titan_Logo-UhBGgJ2d.svg";
